/**
 * PanAm Theme - Pan American World Airways Inspired Theme
 * Classic blue and white professional color scheme
 */

import type { ThemeConfig } from 'antd';

/**
 * PanAm Theme Color Tokens
 */
export const PANAM_THEME_TOKENS = {
	// Base colors
	fontSize: 10,
	fontFamily:
		"'Avenir Next LT Pro', AvenirNextLTPro, 'Avenir Next', Avenir, -apple-system, sans-serif",
	colorBgBase: '#0a1929', // Deep navy blue
	colorTextBase: '#ffffff',
	colorBorder: '#1e3a5f', // Navy border
	controlOutline: 'transparent',
	controlOutlineWidth: 0,

	// Primary colors - PanAm Blue
	colorPrimary: '#003E7E',
	colorPrimaryHover: '#0066B3',
	colorPrimaryActive: '#002850',

	// Link colors - Lighter blue accent
	colorLink: '#0099FF',
	colorLinkHover: '#33ADFF',
	colorLinkActive: '#0077CC',

	// Layout
	borderRadius: 0,
} as const;

/**
 * PanAm Theme Component Customizations
 */
export const PANAM_COMPONENTS: ThemeConfig['components'] = {
	Button: {
		// Primary button - PanAm Blue
		colorPrimary: '#003E7E',
		colorTextLightSolid: '#ffffff',
		primaryShadow: '0 4px 8px rgba(0,62,126,0.3)',
		colorPrimaryHover: '#0066B3',
		colorPrimaryActive: '#002850',

		// Default button
		colorBgContainer: '#1e3a5f',
		colorBorder: '#2d4a70',
		colorText: '#ffffff',
		defaultHoverBg: '#2d4a70',
		defaultHoverColor: '#ffffff',
		defaultActiveBg: '#14283d',
	},
	Modal: {
		contentBg: '#142536',
		headerBg: '#142536',
		titleColor: '#ffffff',
		colorText: '#ffffff',
	},
	Input: {
		colorBgContainer: '#1e3a5f',
		colorText: '#ffffff',
		colorBorder: '#2d4a70',
		activeShadow: '0 0 0 2px rgba(0,62,126,0.4)',
		colorTextPlaceholder: '#b3c5d6',
		hoverBorderColor: '#003E7E',
		activeBorderColor: '#003E7E',
	},
	Select: {
		hoverBorderColor: '#003E7E',
		activeBorderColor: '#003E7E',
	},
	DatePicker: {
		hoverBorderColor: '#003E7E',
		activeBorderColor: '#003E7E',
	},
	Form: {
		labelColor: '#ffffff',
		colorText: '#ffffff',
	},
	Table: {
		colorBgContainer: '#0a1929',
		headerColor: '#ffffff',
		headerBg: '#142536',
	},
	Card: {
		colorBgContainer: '#142536',
	},
	Checkbox: {
		colorPrimary: '#0099FF', // Light blue
		colorPrimaryHover: '#33ADFF',
		borderRadius: 4,
		colorWhite: '#0a1929',
	},
	Menu: {
		itemBg: '#142536',
		itemSelectedBg: '#003E7E',
		itemSelectedColor: '#ffffff',
	},
};

/**
 * PanAm Layout Colors
 */
export const PANAM_LAYOUT_COLORS = {
	navbar: {
		background: '#142536',
		height: '50px',
		boxShadow: '0 2px 8px rgba(0,62,126,0.3)',
	},
	content: {
		background: '#0a1929',
		marginTop: 35,
		paddingVertical: 24,
	},
	layout: {
		background: '#0a1929',
		minHeight: '100vh',
	},
} as const;
